module.exports = __webpack_public_path__ + "img/ruby.f68055d8.webp";